import { useQuery } from '@tanstack/react-query';
import { getVariationImages } from '../api/variationImagesApi';
import { useAuthStore } from '../../auth/stores/authStore';

export const variationImageKeys = {
  all: ['variationImages'] as const,
  images: (variationRequestId: string, isAuthenticated: boolean) =>
    [
      ...variationImageKeys.all,
      { variationRequestId, isAuthenticated },
    ] as const,
};

export function useVariationImages(variationRequestId: string | null) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: variationImageKeys.images(
      variationRequestId || '',
      isAuthenticated
    ),
    queryFn: () => getVariationImages(variationRequestId!),
    enabled: isAuthenticated && !!variationRequestId,
    staleTime: 5 * 60 * 1000,
  });
}
